// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

const accountSummaryUrl = "api/vmi/accountsummary";

export interface AccountStatementModel {
    balance: string;
    statementDate: string;
    statementId: string;
}

export interface AccountSummaryModel {
    creditLimit: string;
    availableCredit: string;
    termsCode: string;
    dateOfLastSale: string;
    dateOfLastPayment: string;
    monthToDatePurchases: string;
    yearToDatePurchases: string;
    agingBucket1: string;
    agingBucket2: string;
    agingBucket3: string;
    agingBucket4: string;
    agingBucket5: string;
    agingBucketFuture: string;
    total: string;
    accountStatementList: AccountStatementModel[];
}

export interface GetAccountSummaryParameter extends ApiParameter {
    numberOfMonthsToLookBack: number;
}

export const getAccountSummary = async (parameter: GetAccountSummaryParameter): Promise<AccountSummaryModel> => {
    const result: AccountSummaryModel = await get<AccountSummaryModel>(accountSummaryUrl, parameter);
    return result;
};
